import React from 'react';
import { SvgIcon, Typography } from '@material-ui/core';
import { useStyle } from './company-summary-item.style';
import { getValidUrl } from 'utils/browser-utils';

type CompanySummaryItemProps = {
    icon: React.ReactNode;
    title: string;
    text: string;
    link?: boolean;
};

export const CompanySummaryItem: React.FC<CompanySummaryItemProps> = ({ icon, title, text, link }) => {
    const classes = useStyle();
    return (
        <li className={classes.content}>
            <SvgIcon className={classes.icon} color="primary">
                {icon}
            </SvgIcon>
            <div>
                <Typography className={classes.title}>{title}</Typography>
                {link ? (
                    <a href={getValidUrl(text)} target="_blank" rel="noopener noreferrer">
                        {text}
                    </a>
                ) : (
                    <Typography className={classes.text}>{text}</Typography>
                )}
            </div>
        </li>
    );
};
